import { SpyneTrait, ViewStream } from "spyne";
import { NestingChildView } from "components/code-playground/examples/NestingChildView";
import { CodePlaygroundExamplesNestingTraits } from "traits/code-playground-examples-nesting-traits";
import { UtilTraits } from "traits/util-traits";

import NestingNodeTmpl from "../components/code-playground/example-templates/disposing-nesting-example-node.tmpl.html";

class NestingExample extends ViewStream {
  constructor(props = {}) {
    props.class = "branch";
    props.template = NestingNodeTmpl;
    super(props);
  }
}

class NestingResetBtn extends ViewStream {
  constructor(props = {}) {
    props.class = "reset";
    props.template = "";
    super(props);
  }
}

class NestingStage extends ViewStream {
  constructor(props = {}) {
    props.id = "nesting-example";
    props.vsid = "reset";
    props.traits = CodePlaygroundExamplesNestingTraits;
    props.childTypeArr = ["child", "grandchild", "ggc", "ggc2", "ggc3"];
    props.addRandom = true;
    props.template = `
         <button class="btn material-symbols-outlined reset" data-reset="true" data-add-random="false" data-child-type="reset"  data-event-type="reset">restart_alt</button>`;
    super(props);
  }

  addActionListeners() {
    return [["CHANNEL_UI_CLICK_EVENT", "codePlayground$AddRootNode", ".reset"]];
  }

  broadcastEvents() {
    return [[".reset", "click"]];
  }

  onRendered() {
    this.codePlayground$AddRootNode();
    this.addChannel("CHANNEL_UI");
  }
}

export class CodePlaygroundExamplesDisposingTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlaygroundDisposing$";

    super(context, traitPrefix);
  }

  static codePlaygroundDisposing$NestingExample() {
    /*
    this.appendView(new NestingChildView({
      addRandom: true

    }), ".example-container");


*/

    this.appendView(new NestingStage(), ".example-container");

    return [
      {
        tabName: "NestingStage",
        scriptString: `    ${NestingStage}`,
      },
      {
        tabName: "NestingView",
        scriptString: `    ${NestingChildView}`,
      },
      {
        tabName: "NestingTraits",
        scriptString: `${CodePlaygroundExamplesNestingTraits}`,
      },
      {
        tabName: "NestingTmpl",
        scriptString: `${UtilTraits.util$EscapeHTMLChars(NestingNodeTmpl)}`,
      },
      {
        tabName: "SCSS",
        scriptString: `
  .root       { background-color: $Supporting-4-400;}
  .child      { background-color: $Supporting-4-300;}
  .grandchild { background-color: $Supporting-4-200;}
  .ggc        { background-color: $Supporting-4-100;}
  .ggc2       { background-color: $Supporting-4-050;}
  .ggc3       { background-color: $Supporting-4-050;}
  .branch {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem;
    padding: .5rem 0 0 0;
    border: 1px solid #999;
    .children {
      display: flex;
    }
    .controls {
      position: relative;
      display: flex;
      width: 100%;
      height: 26px;
      .btn {
        color: #aaa;
        background: darkblue;
        width: 50%;
      }
    }
  }`,
      },
    ];
  }
}
